import { Grid } from '@mui/material';

import { Heading } from 'components/Typography';

const Gridfield = ({ label, sx, children, gap, ...props }) => {
  return (
    <Grid item xs={12} sx={sx}>
      <Heading as="h6" mb={1} {...props} content={label} />
      {children}
    </Grid>
  );
};

export default Gridfield;
